<template>
  <div class="tarja-container" :style="containerPosition">
    <Wrapper class="tarja-svg" />
    <div class="header-text">INSCRITOS</div>
    <div class="description-text">
      {{ animatedCount }}
    </div>
  </div>
</template>

<script>
import Wrapper from "@/assets/tarjas/GETV/total_inscritos.svg";

export default {
  props: {
    count: {
      type: String,
      required: true
    },
    posicaoCard: {
      type: String,
      default: 'esquerda'
    },
  },
  components: {
    Wrapper,
  },
  data() {
    return {
      animatedCount: this.count,
      animationFrame: null,
    };
  },
  watch: {
    count(newVal) {
      this.animateCount(newVal);
    }
  },
  computed: {
    containerPosition() {
      const positions = {
        esquerda: 'left: 20px; transform-origin: bottom left;',
        centro: 'left: calc(50% - 250px); transform-origin: bottom center;',
        direita: 'right: 20px; transform-origin: bottom right;'
      };
      return positions[this.posicaoCard] || positions.esquerda;
    },
  },
  methods: {
    animateCount(targetCount) {
      const currentNum = parseInt(this.animatedCount.replace(/\./g, '')) || 0;
      const targetNum = parseInt(targetCount.replace(/\./g, '')) || 0;

      if (currentNum === targetNum) return;

      const duration = 2000;
      const startTime = performance.now();
      const difference = targetNum - currentNum;

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        const easeInOutCubic = progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        const current = Math.floor(currentNum + (difference * easeInOutCubic));
        this.animatedCount = current.toLocaleString('pt-BR');

        if (progress < 1) {
          this.animationFrame = requestAnimationFrame(animate);
        } else {
          this.animatedCount = targetCount;
        }
      };

      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }

      this.animationFrame = requestAnimationFrame(animate);
    }
  },
  beforeDestroy() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
  }
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "GlobotipoPlacar";
  src: url("@/assets/fonts/GlobotipoPlacar-Bold.otf") format("opentype");
}

.tarja-container {
  position: fixed;
  bottom: 0;
  width: 500px;
  height: 215px;
  transform: scale(0.7);
}

.tarja-svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 500px;
  height: 215px;
}

.header-text {
  position: absolute;
  bottom: 132px;
  left: 50px;
  z-index: 100000;
  font-family: "GlobotipoPlacar", sans-serif;
  font-size: 1.9rem;
  font-weight: bold;
  font-style: italic;
  color: #fff;
  width: 240px;
  text-transform: uppercase;
}

.description-text {
  position: absolute;
  bottom: 50px;
  left: 100px;
  z-index: 100000;
  font-family: "GlobotipoPlacar", sans-serif;
  color: rgb(91, 11, 193);
  font-weight: 600;
  font-size: 3.9rem;
  width: 450px;
  height: 60px;
  display: flex;
  align-items: center;
}
</style>
